import "../../assets/css/HeaderNewWebsite.css";
import logo from "../../assets/img/cropped-Axian-logo@2x.png";
import defaultLang, {englishLang} from "../../config";
import {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {getoneactualite, getoneactualitebyslug,} from "../../services/ActualiteService";
import {listLanguage} from "../../services/OtherService";

export default function HeaderNewWebsite() {
  const [localStorageChange, setLocalStorageChange] = useState(
      JSON.parse(localStorage.getItem("lang")) || defaultLang,
  );
  const location = useLocation();
  const navigate = useNavigate();
  const textsFr = {
    Identity: "Identité",
    Cluster: "Pôles",
    Commitment: "Engagement",
    Investors: "Investisseurs",
    News: "Actualités",
    Career: "Carrières",
    Contact: "Contact",
    linkIdentity: "https://www.axian-group.com/identite/",
    linkCluster: "https://www.axian-group.com/poles/",
    linkCommitment: "https://www.axian-group.com/engagements/",
    linkHomepage: "https://www.axian-group.com/fr/accueil/",
    linkInvestor: "https://www.axian-group.com/investors/",
    linkNews: "https://mediaroom.axian-group.com/",
    linkCareer: "https://www.axian-group.com/carrieres/",
    linkContact: "https://www.axian-group.com/contact/",
    linkAE: "https://www.axian-energy.com/fr/",
    linkFinancialServices:
        "https://www.axian-group.com/fr/poles/axian-financial-services/",
    linkDigibankFintech:
        "https://www.axian-group.com/fr/poles/axian-digibank-fintech/",
    linkProperties: "https://www.axian-group.com/fr/poles/axian-properties/",
    linkTelecom: "https://www.axian-telecom.com/",
  };
  const textsEn = {
    Identity: "Identity",
    Cluster: "Cluster",
    Commitment: "Commitment",
    Investors: "Investors",
    News: "News",
    Career: "Career",
    Contact: "Contact",
    linkIdentity: "https://www.axian-group.com/en/identity/",
    linkCommitment: "https://www.axian-group.com/en/commitment/",
    linkHomepage: "https://www.axian-group.com/",
    linkInvestor: "https://www.axian-group.com/en/investors/",
    linkNews: "https://mediaroom.axian-group.com/",
    linkCareer: "https://www.axian-group.com/en/career/",
    linkContact: "https://www.axian-group.com/en/contact-2/",
    linkAE: "https://www.axian-group.com/en/axian-energy-2/",
    linkFinancialServices:
        "https://www.axian-group.com/en/cluster/axian-financial-services/",
    linkDigibankFintech:
        "https://www.axian-group.com/en/cluster/axian-digibank-fintech/",
    linkProperties: "https://www.axian-group.com/en/cluster/axian-properties/",
    linkTelecom: "https://www.axian-telecom.com/",
  };
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSearch = () => setSearchOpen(!searchOpen);
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const [languages, setLanguages] = useState([]);
  const callChangeLanguage = async (lang) => {
    localStorage.setItem("lang", JSON.stringify(lang));
    const currentPath = location.pathname;
    const pathSplit = currentPath.split("/");
    if (pathSplit.length >= 3) {
      if (pathSplit[1] === "actualite" || pathSplit[1] === "news") {
        const reponse = await getoneactualitebyslug(pathSplit[2]);
        if (reponse !== undefined) {
          if (reponse.status === 200) {
            if (reponse.data.idtraduction) {
              const trad = await getoneactualite(reponse.data.idtraduction);
              if (trad) {
                if (trad.status === 200) {
                  navigate("/" + pathSplit[1] + "/" + trad.data.slug);
                }
              } else {
                navigate("/");
              }
            } else {
              navigate("/");
            }
          }
        }
      }
    }
    window.location.reload();
  };
  const lesLangues = async () => {
    const reponse = await listLanguage();
    if (reponse.status === 200) {
      setLanguages(reponse.data);
    }
  };
  useEffect(() => {
    lesLangues();
  }, []);

  return (
      <div className="">
        {/* Search Overlay */}
        <div className={`search-overlay ${searchOpen ? "" : "hidden"}`}>
          <div className="search-box">
            <div className="header-fluid container-fluid">
              <div className="row">
                <div className="col-12">
                  <form method="get" className="search-form">
                    <div className="search-input-wrapper">
                      <input
                          type="text"
                          name="s"
                          placeholder="Rechercher..."
                          className="search-input"
                      />
                      <button type="submit" className="search-submit">
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <span className="close-search" onClick={toggleSearch}>
            &times;
          </span>
          </div>
        </div>

        {/* Desktop Header */}
        <nav className="header-desktop container-fluid py-3">
          <div className="nav-wrapper">
            <div className="row align-items-center justify-content-between flex-nowrap">
              {/* Left Menu */}
              <div className="col d-flex justify-content-start align-items-center flex-nowrap gap-3 gap-sm-3 gap-md-4 gap-xl-4">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkIdentity
                          : textsFr.linkIdentity
                    }
                    className="nav-link p-0 gris-charbon"
                >
                  <h6 className="mb-0">
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Identity
                        : textsFr.Identity}
                  </h6>
                </a>
                <div className="custom-dropdown-container d-flex align-items-center">
                <span className="custom-dropdown-toggle gris-charbon d-flex align-items-center">
                  <h6 className="mb-0 me-1">
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Cluster
                        : textsFr.Cluster}
                  </h6>
                  <i className="fas fa-chevron-down"></i>
                </span>
                  <ul className="custom-dropdown-menu">
                    <li>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkAE
                                : textsFr.linkAE
                          }
                          target="_blank"
                      >
                        <p className="mb-0">AXIAN Energy</p>
                      </a>
                    </li>

                    <li>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkFinancialServices
                                : textsFr.linkFinancialServices
                          }
                          target="_blank"
                      >
                        <p className="mb-0">AXIAN Financial Sevices</p>
                      </a>
                    </li>

                    <li>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkDigibankFintech
                                : textsFr.linkDigibankFintech
                          }
                          target="_blank"
                      >
                        <p className="mb-0">AXIAN Digibank & Fintech</p>
                      </a>
                    </li>

                    <li>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkProperties
                                : textsFr.linkProperties
                          }
                          target="_blank"
                      >
                        <p className="mb-0">AXIAN Properties</p>
                      </a>
                    </li>

                    <li>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkTelecom
                                : textsFr.linkTelecom
                          }
                          target="_blank"
                      >
                        <p className="mb-0">AXIAN Telecom</p>
                      </a>
                    </li>
                  </ul>
                </div>
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkCommitment
                          : textsFr.linkCommitment
                    }
                    className="nav-link p-0 gris-charbon"
                >
                  <h6 className="mb-0">
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Commitment
                        : textsFr.Commitment}
                  </h6>
                </a>
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkInvestor
                          : textsFr.linkInvestor
                    }
                    className="nav-link p-0 gris-charbon"
                >
                  <h6 className="mb-0">
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Investors
                        : textsFr.Investors}
                  </h6>
                </a>
              </div>

              {/* Logo */}
              <div
                  className="col-auto text-center px-3 logo-center-col"
              >
                {/* <div className="custom-logo mx-auto"> */}
                <Link
                    to={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkHomepage
                          : textsFr.linkHomepage
                    }
                    className="custom-logo mx-auto"
                >
                  <img src={logo} alt="Logo" />
                </Link>
                {/* </div> */}
              </div>

              {/* Right Menu */}
              <div className="col d-flex justify-content-end align-items-center flex-nowrap gap-3 gap-sm-3 gap-md-4 gap-xl-4">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkNews
                          : textsFr.linkNews
                    }
                    className="nav-link p-0 gris-charbon"
                >
                  <h6 className="mb-0">
                    {localStorageChange.code === englishLang.code
                        ? textsEn.News
                        : textsFr.News}
                  </h6>
                </a>
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkCareer
                          : textsFr.linkCareer
                    }
                    className="nav-link p-0 gris-charbon"
                >
                  <h6 className="mb-0">
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Career
                        : textsFr.Career}
                  </h6>
                </a>
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkContact
                          : textsFr.linkContact
                    }
                    className="bouton bouton-primary"
                >
                  {localStorageChange.code === englishLang.code
                      ? textsEn.Contact
                      : textsFr.Contact}
                </a>

                {/* Search + language*/}
                <div className="d-flex align-items-center ms-auto gap-1">
                  <li className="nav-link language-selector">
                    <select
                        className="custom-form lang-link"
                        value={localStorageChange.code || ""}
                        onChange={(e) => {
                          const selected = languages.find(
                              (lang) => lang.code === e.target.value,
                          );
                          if (selected) {
                            setLocalStorageChange(selected);
                            callChangeLanguage(selected);
                          }
                        }}
                    >
                      {languages.map((item) => (
                          <option key={item.code} value={item.code}>
                            {item.code}
                          </option>
                      ))}
                    </select>
                  </li>

                  <li className="nav-link search-icon" onClick={toggleSearch}>
                    <i className="fas fa-search gris-charbon"></i>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {/* Mobile Header */}
        <div className="header-mobile">
          <div className="mobile-header-container position-relative d-flex align-items-center justify-content-center">
            <div className="mobile-menu-toggle position-absolute start-0">
              <button className="btn-menu" onClick={toggleMobileMenu}>
                <i className="fas fa-bars"></i>
              </button>
            </div>
            <div className="mobile-logo">
              <img src={logo} alt="Logo" />
            </div>

            <div className="mobile-actions position-absolute end-0 d-flex align-items-center gap-2">
              <select
                  className="mobile-lang-selector"
                  value={localStorageChange.code || ""}
                  onChange={(e) => {
                    const selected = languages.find(
                        (lang) => lang.code === e.target.value,
                    );
                    if (selected) {
                      setLocalStorageChange(selected);
                      callChangeLanguage(selected);
                    }
                  }}
              >
                {languages.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.code}
                    </option>
                ))}
              </select>

              <li className="nav-link search-icon" onClick={toggleSearch}>
                <i className="fas fa-search gris-charbon"></i>
              </li>
            </div>
          </div>

          {/* Mobile Menu */}
          <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
            <div className="mobile-menu-header d-flex justify-content-between align-items-center px-3 pt-3">
              <div className="mobile-logo mb-3">
                <img src={logo} alt="Logo" />
              </div>
              <button className="btn-menu-close" onClick={toggleMobileMenu}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <ul className="mobile-menu-list">
              <li className="mobile-menu-item">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkIdentity
                          : textsFr.linkIdentity
                    }
                    className="mobile-menu-link"
                >
                  <h5>
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Identity
                        : textsFr.Identity}
                  </h5>
                </a>
              </li>
              <li className="mobile-menu-item">
              <span className="mobile-menu-link">
                <h5>
                  {localStorageChange.code === englishLang.code
                      ? textsEn.Cluster
                      : textsFr.Cluster}
                </h5>
              </span>
                <ul className="mobile-submenu">
                  <li>
                    <h5>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkAE
                                : textsFr.linkAE
                          }
                          className="mobile-submenu-link"
                      >
                        AXIAN Energy
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkFinancialServices
                                : textsFr.linkFinancialServices
                          }
                          className="mobile-submenu-link"
                      >
                        AXIAN Financial Services
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkDigibankFintech
                                : textsFr.linkDigibankFintech
                          }
                          className="mobile-submenu-link"
                      >
                        AXIAN Digibank & Fintech
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkProperties
                                : textsFr.linkProperties
                          }
                          className="mobile-submenu-link"
                      >
                        AXIAN Properties
                      </a>
                    </h5>
                  </li>
                  <li>
                    <h5>
                      <a
                          href={
                            localStorageChange.code === englishLang.code
                                ? textsEn.linkTelecom
                                : textsFr.linkTelecom
                          }
                          className="mobile-submenu-link"
                      >
                        AXIAN Telecom
                      </a>
                    </h5>
                  </li>
                </ul>
              </li>
              <li className="mobile-menu-item">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkCommitment
                          : textsFr.linkCommitment
                    }
                    className="mobile-menu-link"
                >
                  <h5>
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Commitment
                        : textsFr.Commitment}
                  </h5>
                </a>
              </li>
              <li className="mobile-menu-item">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkInvestor
                          : textsFr.linkInvestor
                    }
                    className="mobile-menu-link"
                >
                  <h5>
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Investors
                        : textsFr.Investors}
                  </h5>
                </a>
              </li>
              <li className="mobile-menu-item">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkNews
                          : textsFr.linkNews
                    }
                    className="mobile-menu-link"
                >
                  <h5>
                    {localStorageChange.code === englishLang.code
                        ? textsEn.News
                        : textsFr.News}
                  </h5>
                </a>
              </li>
              <li className="mobile-menu-item">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkCareer
                          : textsFr.linkCareer
                    }
                    className="mobile-menu-link"
                >
                  <h5>
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Career
                        : textsFr.Career}
                  </h5>
                </a>
              </li>
              <li className="mobile-menu-item">
                <a
                    href={
                      localStorageChange.code === englishLang.code
                          ? textsEn.linkContact
                          : textsFr.linkContact
                    }
                    className="btn-contact-menu-mobile bouton bouton-primary"
                >
                  <h5>
                    {localStorageChange.code === englishLang.code
                        ? textsEn.Contact
                        : textsFr.Contact}
                  </h5>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
  );
}
